import Ship from './ship.js';

export default class BattleShip extends Ship {
  constructor() {
    super(4, 'battleship');
  }
}
